<template>
  <footer>
    <div class="footer-text">
      <a href="mailto:info@marionpolakstichting.nl"
        >info@marionpolakstichting.nl</a
      >
      <p>KvK: 32088165</p>
      <p>RSIN: 8104.04.485</p>
    </div>
    <div class="copy">
      &copy; {{ new Date().getFullYear() }} - Marion G. Polak Stichting
    </div>
    <div class="fishionaire">
      by <a href="https://www.fishionaire.com" target="_blank">Fishionaire</a>
    </div>
  </footer>
</template>

<!-- Script
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<script>
export default {
  name: "footerComponent",
  data() {
    return {};
  },
  methods: {},
};
</script>

<!-- Style
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<style lang="scss" scoped>
footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  padding: $padding-mobile;
  background-color: $dark-grey;
  color: white;
}

.footer-text {
  p {
    margin-top: 4px;
    margin-bottom: 4px;
  }
  @include maxWidthCenter();
}

a {
  color: $bright-green;
}

.copy {
  text-align: center;

  @include max-medium {
    margin-top: 20px;
  }
}
.fishionaire {
  text-align: center;
  font-size: 76%;
  color: $light-grey;
}
</style>
